import CountryFlag, { isoAlpha2FromHeadquartersCountry } from "@/components/shared/CountryFlag";
import { createElement, type ReactNode } from "react";

export { isoAlpha2FromHeadquartersCountry };

/** ISO 3166-1 alpha-2 → regional indicator flag emoji (e.g. IN → 🇮🇳).
 *
 * NOTE: Unicode flag emoji rendering is inconsistent on Windows. Prefer CountryFlag for UI.
 */
export function regionalIndicatorFlagEmoji(alpha2: string): string | null {
  const c = alpha2.toUpperCase();
  if (c.length !== 2 || !/^[A-Z]{2}$/.test(c)) return null;
  const base = 0x1f1e6;
  const letterA = 0x41;
  return String.fromCodePoint(
    base + (c.charCodeAt(0) - letterA),
    base + (c.charCodeAt(1) - letterA)
  );
}

/** ISO alpha-2 → bordered flag image (shared site-wide structure). */
export function flagIconFromAlpha2(alpha2?: string | null): ReactNode | null {
  const c = alpha2?.trim().toUpperCase();
  if (!c || c.length !== 2 || !/^[A-Z]{2}$/.test(c)) return null;
  return createElement(CountryFlag, { alpha2: c });
}

/** Headquarters country name → bordered flag image (shared site-wide structure). */
export function flagEmojiFromHeadquartersCountry(countryName?: string | null): ReactNode | null {
  if (!countryName?.trim()) return null;
  return createElement(CountryFlag, { country: countryName });
}
